import React, { useState, useEffect } from 'react';
import { css } from '@emotion/react';
import { Button } from 'react-bootstrap';
import { connect } from 'react-redux';
import { fetchWrapper } from '../../../../_helpers';
import { PeopleItem, StyledPeople } from './styles/PeopleStyles';
import { toast } from 'react-toastify';
import OurAccordion from '@/_elements/OurAccordion';

function People({
    currUser,
    roomId,
    channelMembers,
    teamMembers,
    rooms,
    conferenceId,
    participants,
    waitingParticipants,
    channelInfo,
    handleMuteParticipant,
    isHost,
    handleRemoveParticipant,
}) {
    const [invitableMembers, setInvitableMembers] = useState([]);

    const [inCallMembers, setInCallMembers] = useState([]);

    useEffect(() => {
        let callParticipantArray = Object.values(participants)
            .filter((participant) => (participant.id || participant._id) !== currUser.id)
            .sort((a, b) => (a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1));
        // console.log(callParticipantArray, 'callParticipantArray');
        setInCallMembers(callParticipantArray);

        let callParticipantIDArray = callParticipantArray.map((participant) => participant.id || participant._id);
        callParticipantIDArray = [...callParticipantIDArray, currUser.id];
        let members;
        if (channelInfo?.type === 'public') {
            members = teamMembers;
        } else {
            members = channelMembers;
        }

        setInvitableMembers(members.filter((member) => !callParticipantIDArray.includes(member.id || member._id)));
    }, [channelInfo?.type, channelMembers, currUser.id, participants, teamMembers]);

    const handleInvite = async (channelMember) => {
        let userId = channelMember.id || channelMember._id;
        try {
            await fetchWrapper.post('conference/invite', {
                conferenceId: conferenceId,
                userIds: [userId],
            });
            toast.info('Invitation sent successfully!');
        } catch (e) {}
    };
    const handleInviteAll = async () => {
        try {
            let invitableMembersId = invitableMembers.map((member) => member._id || member.id);
            await fetchWrapper.post('conference/invite', {
                conferenceId: conferenceId,
                userIds: invitableMembersId,
            });
            toast.info('Invitation sent successfully!');
        } catch (e) {
            console.log(e);
        }
    };

    const removeParticipant = (participantId) => {
        let tempInCallMembers = [...inCallMembers];
        let removedParticipant;
        tempInCallMembers = tempInCallMembers.filter((participant) => {
            if ((participant.id || participant._id) === participantId) {
                removedParticipant = participant;
                return false;
            }
            return true;
        });
        setInCallMembers(tempInCallMembers);
        setInvitableMembers([...invitableMembers, removedParticipant]);
        handleRemoveParticipant(participantId);
    };
    return (
        <StyledPeople>
            <div>
                {isHost && waitingParticipants && waitingParticipants.length > 0 && (
                    <OurAccordion
                        title={
                            <div>
                                <span>Waiting To Be Admitted</span>
                                <span className="badge badge-warning ml-2">{waitingParticipants.length}</span>
                            </div>
                        }
                    >
                        <div>
                            <div
                                css={css`
                                    max-height: 55vh;
                                    overflow-y: auto;
                                    padding: 0 1rem;
                                `}
                            >
                                <div className="d-flex justify-content-end">
                                    <Button
                                        onClick={() => {
                                            try {
                                                fetchWrapper.patch(`/conference/${conferenceId}/settings`, {
                                                    accessType: 'open',
                                                });
                                            } catch (error) {
                                                console.error(error);
                                                toast.error('Failed to update settings');
                                            }
                                        }}
                                        variant="secondary"
                                    >
                                        Admit All
                                    </Button>
                                </div>

                                {waitingParticipants?.map((participant) => {
                                    return (
                                        <>
                                            <PeopleItem
                                                key={participant.id}
                                                people={participant}
                                                isHost={isHost}
                                                handleRemoveParticipant={removeParticipant}
                                                handleMuteParticipant={handleMuteParticipant}
                                                isWaiting={true}
                                            />
                                        </>
                                    );
                                })}
                            </div>
                        </div>
                    </OurAccordion>
                )}

                <OurAccordion title={'In Call'}>
                    <div>
                        <div
                            css={css`
                                max-height: 55vh;
                                overflow-y: auto;
                                padding: 0 1rem;
                            `}
                            key={participants}
                        >
                            {inCallMembers?.map((participant) => {
                                return (
                                    <>
                                        <PeopleItem
                                            key={participant.id}
                                            people={participant}
                                            isHost={isHost}
                                            handleRemoveParticipant={removeParticipant}
                                            handleMuteParticipant={handleMuteParticipant}
                                        />
                                    </>
                                );
                            })}
                        </div>
                    </div>
                </OurAccordion>
                <OurAccordion title={'Invite'} defaultShow={false}>
                    <div>
                        <div
                            css={css`
                                max-height: 55vh;
                                overflow-y: auto;
                                padding: 0 1rem;
                            `}
                        >
                            {invitableMembers?.length ? (
                                <div
                                    css={css`
                                        display: flex;
                                        justify-content: flex-end;
                                        margin-top: 1rem;
                                    `}
                                >
                                    <Button className="BlueButton" onClick={handleInviteAll}>
                                        Invite all
                                    </Button>
                                </div>
                            ) : null}

                            {invitableMembers
                                .sort((a, b) => (a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1))
                                .map((channelMember) => (
                                    <PeopleItem
                                        key={channelMember.id || channelMember._id}
                                        people={channelMember}
                                        handleInvite={handleInvite}
                                    />
                                ))}
                        </div>
                    </div>
                </OurAccordion>
            </div>
        </StyledPeople>
    );
}
const mapStateToProps = (state) => ({
    currUser: state.user.user,
    rooms: state.rooms.teamRooms,
    teamMembers: state.teams.teamMembers,
    channelMembers: state.rooms.channelMembers,
});

export default connect(mapStateToProps)(People);
